import request from '@/utils/request'
import {
    ready
} from 'jquery'
import qs from 'qs'

/**
 * 用户登录
 */
export function login(data) {
    return request({
        url: 'login/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
/**
 * 个人账号登录
 */
export function personloginApi(data) {
    return request({
        url: 'personlogin/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
/**
 * IP登录
 */
export function iplogin(query) {
    return request({
        url: 'iplogin/',
        method: 'get',
        params: query,
    })
}
/**
 * 青梨登录
 */
export function qinglilogin(data) {
    return request({
        url: 'qllogin/',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
/**
 * chatlibrary提问接口
 */
export function post_chatlib(data) {
    return request({
        url: 'chatlib/qa/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
/**
 * chatlibrary侧边导航
 */
export function get_chatlib(query) {
    return request({
        url: 'chatlib/qu/',
        method: 'get',
        params: query,
    })
}
/**
 * 语音文件上传
 */
export function speakApi(data) {
    return request({
        url: 'chatlib/upload/',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: data,
    })
}

/**
 * chatsearch提问接口
 */
export function post_chatsearch(data) {
    return request({
        url: 'chatsearch/qa/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}
/**
 * chatsearch侧边导航
 */
export function get_chatsearch(query) {
    return request({
        url: 'chatsearch/qu/',
        method: 'get',
        params: query,
    })
}


/**
 * chatsearch提问接口
 */
export function test(data) {
    return request({
        url: 'test/',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'text/event-stream; charset=utf-8'
        },
        // data: qs.stringify(data),
    })
}

/**
 * chatlibrary提问接口
 */
export function upDown(data) {
    return request({
        url: 'up_or_down/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}


/**
 * 日志接口
 */
export function eventLog(data) {
    return request({
        url: 'eventlog/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}


/**
 * chatcqu
 */
export function chatCqu(data) {
    return request({
        url: 'chatcqu/',
        method: 'post',
        data,

    })
}


export function testApi(query) {
    return request({
        url: 'test/',
        method: 'get',
        params: query,

    })
}




export function testOne(data) {
    return request({
        url: 'test1/',
        method: 'post',
        data,
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // },
        // data: qs.stringify(data),
    })
}

/**
 * chatresearch 文献搜索接口
 * @param {*} data 
 * @returns 
 */
export function chat_research(data) {
    return request({
        url: 'chatresearch/search/',
        method: 'post',
        data,
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // },
        // data: qs.stringify(data),
    })
}
/**
 * chatresearch 侧边聚合接口
 * @param {*} data 
 * @returns 
 */
export function sideBarListApi(data) {
    return request({
        url: 'chatresearch/aggs/',
        method: 'post',
        data
    })
}


export function get_similar_question(data) {
    return request({
        url: 'chatlib/get_similar_question/',
        method: 'get',
        params: data,
    })
}

/**
 * 测试
 */

export function ceshiApi(text, count, page, size, type) {
    return request({
        url: '/chatresearch/faiss_milvus/',
        method: 'get',
        params: {
            text,
            count,
            page,
            size,
            type
        }
    })
}

/**
 * 问答测试
 */

export function quCeshiApi(data) {
    return request({
        url: '/chatlib/qa_test/',
        method: 'post',
        data
    })
}

/**
 * journal测试
 */
export function journalApi(code) {
    return request({
        url: '/journal/qu/',
        method: 'get',
        params:{
            code
        }
    })
}

/**
 * chatArchives
 */
export function journalFellowApi(data) {
    return request({
        url: 'journal/fellows/',
        method: 'post',
        data
    })
}

export function fellowSimilarApi1(data) {
    return request({
        url: 'journal/fellows/similar/',
        method: 'post',
        data
    })
}

/**
 * 获取文章详情
 * @param {*} data 
 * @returns 
 */
export function fetchArticleDetailApi(data) {
    return request({
        url: 'journal/fellows/detail/',
        method: 'post',
        data
    })
}



/**
 * 机构列表获取
 */
export function organList(data) {
    return request({
        url: 'organ/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}

/**
 * 发送短信验证码
 */
export function sendCode(data) {
    return request({
        url: 'sendmsg/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}

/**
 *个人账号注册
 */
export function enrollAcc(data) {
    return request({
        url: 'register/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}

/**
 * 获取邮箱验证码
 * @param {*} data 
 * @returns 
 */
export function getEmailCodeApi(data) {
    return request({
        url: 'sendEmailmsg/',
        method: 'post',
        data
    })
}
/**
 *找回密码
 */
export function backPass(data) {
    return request({
        url: 'forgetpassword/',
        method: 'post',
        // data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify(data),
    })
}

/**
 *发送邮箱验证码
 */
export function emailCode(data) {
    return request({
        url: 'forgetpassword/',
        method: 'get',
        params: data,
    })
}


export function chat_open(data) {
    return request({
        url: 'chatresearch/search_v2/',
        method: 'post',
        data,
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // },
        // data: qs.stringify(data),
    })
}